import axios from "@/plugins/axios";

let url = "/api/v1/me/purchases";

export default {
    getPurchases(data){
        return axios.get(url, data).then(result => result.data);
    },
    putPurchase(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    }
}
